import getPlatform from '@mattp0123/get-platform';
import { $, $$, getLang, loadTranslations } from './utils';

(async function main() {
  const lang = getLang();
  const platform = getPlatform();
  const translations = await loadTranslations(lang);
  const l10nElements = $$('[data-l10n-key]');
  l10nElements.forEach((element) => {
    const key = (element as HTMLElement).dataset['l10nKey']!;
    element.textContent = translations[key as keyof typeof translations];
  });

  const urlParams = new URLSearchParams(location.search);
  const token = urlParams.get('token');

  if (token !== null) {
    $('div.token')!.textContent = token.replace(/[^a-zA-Z0-9_\-?&=]/g, '');
  }

  const Toast = $('.toast')!;
  let toastTimerId: NodeJS.Timeout;
  $('button.copy')!.addEventListener('click', async () => {
    const token = $('div.token')!.textContent!;
    await navigator.clipboard.writeText(token);
    Toast.classList.remove('v-hidden');

    if (toastTimerId) {
      clearTimeout(toastTimerId);
    }

    toastTimerId = setTimeout(() => {
      Toast.classList.add('v-hidden');
    }, 3000);
  });

  $('button.download')!.addEventListener('click', () => {
    switch (platform) {
      case 'iOS':
        return location.replace(
          'https://itunes.apple.com/app/forest-stay-focused-stop-phubbing/id866450515'
        );

      case 'Android':
        if (lang === 'zh_CN') {
          return location.replace('https://www.coolapk.com/apk/cc.forestapp');
        }

        return location.replace(
          'https://play.google.com/store/apps/details?id=cc.forestapp'
        );

      default:
        return location.replace('https://forestapp.cc');
    }
  });

  /**
   * Redirect to Forest app
   * these lines of code must be placed at the bottom
   * the scheme exception can't be handle by try catch block
   */
  if (platform === 'Android' || platform === 'iOS') {
    const parsedQuery = location.search.replace(/[^a-zA-Z0-9_\-?&=]/g, '');
    return location.replace(`forest://join_room${parsedQuery}`);
  }
})();
